import { render } from "./PerPerson.vue?vue&type=template&id=b9ed6dda&scoped=true"
import script from "./PerPerson.vue?vue&type=script&lang=js"
export * from "./PerPerson.vue?vue&type=script&lang=js"

import "./PerPerson.vue?vue&type=style&index=0&id=b9ed6dda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9ed6dda"]])

export default __exports__